import { Injectable, EventEmitter } from '@angular/core';
import { ActiveBreakpoint, ScreenOrientation } from './variables';

@Injectable({
  providedIn: 'root'
})
export class GlobalUtilsService {
  activeScreen: ActiveBreakpoint;
  screenOrientation: ScreenOrientation;
  mobilePopupNavIsOpen: boolean;
  navDarkTheme: boolean;
  mobileNavBehaviorIsDisable: boolean;

  viewportChanged: EventEmitter<any>;
  initialLoadingIsFinished: EventEmitter<any>;

  constructor() {
    this.screenOrientation = ScreenOrientation.Landscape;
    this.mobilePopupNavIsOpen = false;
    this.navDarkTheme = false;
    this.mobileNavBehaviorIsDisable = false;
    this.viewportChanged = new EventEmitter();
    this.initialLoadingIsFinished = new EventEmitter();
  }

  isTablet() {
    return this.activeScreen === ActiveBreakpoint.Tablet;
  }

  isDesktop() {
    return this.activeScreen === ActiveBreakpoint.Desktop;
  }

  isMobile() {
    return this.activeScreen === ActiveBreakpoint.Mobile;
  }
}
